<template>
    <v-layout justify-center>
        <v-responsive max-width="1440" width="100%">
            <list-heading v-model="showsSearch" title="작품 목록" showsFilterButton>
                <template #add-button>
                    <work-classifications-view>
                        <template #activator="{ attrs, on }">
                            <v-tooltip left transition="fade-transition">
                                <template #activator="tooltipProps">
                                    <span v-bind="tooltipProps.attrs" v-on="tooltipProps.on">
                                        <v-btn icon text v-bind="attrs" v-on="on">
                                            <v-icon>mdi-cog</v-icon>
                                        </v-btn>
                                    </span>
                                </template>
                                작품상세정보 기본값 설정
                            </v-tooltip>
                        </template>
                    </work-classifications-view>
                </template>
                <template #buttons>
                    <work-list-mode-auction />
                </template>
            </list-heading>

            <list-search-default v-bind="{ showsSearch, loading, searchKeys }" />

            <v-data-table v-bind="{ headers, items, itemsPerPage: -1 }" hide-default-footer disable-sort class="v-sheet--outlined">
                <template v-for="header in headers.filter((header) => header.hasOwnProperty('formatter'))" #[`item.${header.value}`]="{ value }"> {{ header.formatter(value) }} </template>

                <template #[`header.category`]="{ header }">
                    <v-layout align-center>
                        <span> {{ header.text }} </span>
                        <auction-category-view v-bind="{ group }">
                            <template #activator="{ attrs, on }">
                                <v-btn x-small text icon class="my-n1" v-bind="attrs" v-on="on">
                                    <v-icon small>mdi-cog</v-icon>
                                </v-btn>
                            </template>
                        </auction-category-view>
                    </v-layout>
                </template>

                <template #[`item.isSoldOut`]="{ value, item }">
                    <v-switch v-model="item.isSoldOut" inset dense hide-details class="pa-0 ma-0" @click="save({ _id: item._id, isSoldOut: !value })">
                        <span slot="label" class="subtitle-2"> {{ value ? "판매완료" : "판매중" }} </span>
                    </v-switch>
                </template>

                <v-row slot="item.imgs" slot-scope="{ value }" align="center" no-gutters>
                    <v-col cols="auto" class="py-4 pr-2">
                        <work-imgs-overlay :imgs="value">
                            <template #activator="{ attrs, on }">
                                <v-img width="48" height="48" :src="value?.[0]?.url" v-bind="attrs" v-on="on" style="cursor: pointer" />
                            </template>
                        </work-imgs-overlay>
                    </v-col>
                    <v-col cols="auto">{{ value?.length || 0 > 1 ? `X ${value.length}` : "" }}</v-col>
                </v-row>

                <template #[`item._bids`]="{ value, item }">
                    <work-bids-list :work="item">
                        <template #activator="{ attrs, on }">
                            <v-btn v-bind="attrs" v-on="on" block height="100%" tile color="secondary"> {{ value?.length }}건 </v-btn>
                        </template>
                    </work-bids-list>
                </template>

                <template #[`item.actions`]="{ item }">
                    <v-btn v-if="isProgram" icon text color="secondary" :disabled="!item.isAuctionEnded" @click="email(item)">
                        <v-icon>mdi-email</v-icon>
                    </v-btn>
                    <work-view :value="item" @input="update">
                        <template #activator="{ attrs, on }">
                            <v-btn v-bind="attrs" v-on="on" text icon color="primary"><v-icon>mdi-pencil</v-icon></v-btn>
                        </template>
                    </work-view>
                    <v-btn icon text color="red" @click="remove(item)">
                        <v-icon>mdi-delete</v-icon>
                    </v-btn>
                </template>
            </v-data-table>

            <v-pagination :value="page" :length="pageCount" :total-visible="11" color="primary" class="my-4" @input="(page) => $router.push({ query: { ...$route.query, page } })" />

            <work-view @input="update">
                <template #activator="{ attrs, on }">
                    <v-btn v-bind="attrs" v-on="on" fab fixed right bottom color="primary" large><v-icon>mdi-pencil</v-icon></v-btn>
                </template>
            </work-view>
        </v-responsive>
    </v-layout>
</template>

<script>
import api from "@/api";
import { AUCTION_CATEGORY_GROUPS, WORK_AUCTION_MODES } from "@/assets/variables";

import WorkView from "@/components/console/auction/work-view.vue";
import ListHeading from "@/components/console/dumb/list-heading.vue";
import ListSearchDefault from "@/components/console/dumb/list-search-default.vue";
import WorkBidsList from "@/components/console/auction/work-bids-list.vue";
import WorkImgsOverlay from "@/components/console/auction/work-imgs-overlay.vue";
import AuctionCategoryView from "@/components/console/auction/categories/auction-category-view.vue";
import WorkClassificationsView from "@/components/console/auction/work-classifications-view.vue";
import WorkListModeAuction from "@/components/console/auction/work-list-mode-auction.vue";

const formatter_dateTime = (value) => value?.toDateTime?.() || "-";

let searchKeys = [
    { value: "subject", text: "작품명" },
    { value: "content", text: "설명" },
];

export default {
    components: {
        WorkView,
        ListHeading,
        ListSearchDefault,
        WorkBidsList,
        WorkImgsOverlay,
        AuctionCategoryView,
        WorkClassificationsView,
        WorkListModeAuction,
    },
    data: () => ({
        works: [],
        summary: { totalCount: 0 },

        limit: 10,

        loading: false,
        showsSearch: true,

        searchKeys,
    }),
    computed: {
        mode_auction() {
            return this.$route.query.mode_auction || null;
        },
        isProgram() {
            return this.mode_auction == WORK_AUCTION_MODES.PROGRAM.value;
        },
        group() {
            switch (this.mode_auction) {
                case WORK_AUCTION_MODES.PRIVATE.value: {
                    return AUCTION_CATEGORY_GROUPS.PRIVATE.value;
                }
                case WORK_AUCTION_MODES.PERMANENT.value: {
                    return AUCTION_CATEGORY_GROUPS.PERMANENT.value;
                }
                default: {
                    return null;
                }
            }
        },
        headers() {
            switch (this.mode_auction) {
                case WORK_AUCTION_MODES.PRIVATE.value:
                case WORK_AUCTION_MODES.PERMANENT.value: {
                    return [
                        { text: "번호", value: "index", width: 60 },
                        { text: "카테고리", value: "category", width: 130, formatter: (value) => value?.name || value || "-" },
                        { text: "LOT", value: "lot", width: 130 },
                        { text: "연도", value: "year", width: 70 },
                        { text: "작가명", value: "author.name.ko", width: 130 },
                        { text: "작품명", value: "subject", width: 130 },
                        { text: "이미지", value: "imgs", width: 110 },
                        { text: "작성일", value: "createdAt", width: 110, formatter: formatter_dateTime },
                        { text: "판매처리", value: "isSoldOut", width: 150 },
                        { text: "", value: "actions", width: 110, align: "right" },
                    ];
                }
                case WORK_AUCTION_MODES.PROGRAM.value: {
                    return [
                        { text: "번호", value: "index", width: 60 },
                        { text: "프로그램", value: "program.subject", width: 110, formatter: (value) => value || "-" },
                        { text: "상태", value: "isAuctionEnded", width: 110, formatter: (value) => (value ? "경매종료" : "-") },
                        { text: "그룹", value: "group", width: 110, formatter: (value) => value || "-" },
                        { text: "LOT", value: "lot", width: 130 },
                        { text: "연도", value: "year", width: 70 },
                        { text: "작가명", value: "author.name.ko", width: 130 },
                        { text: "작품명", value: "subject", width: 130 },
                        { text: "이미지", value: "imgs", width: 110 },
                        { text: "응찰내역", value: "_bids", width: 110 },
                        { text: "작성일", value: "createdAt", width: 110, formatter: formatter_dateTime },
                        { text: "", value: "actions", width: 140, align: "right" },
                    ];
                }
                default: {
                    return [
                        { text: "번호", value: "index", width: 60 },
                        { text: "유형", value: "modeText_auction", width: 100 },
                        { text: "LOT", value: "lot", width: 130 },
                        { text: "연도", value: "year", width: 70 },
                        { text: "작가명", value: "author.name.ko", width: 130 },
                        { text: "작품명", value: "subject", width: 130 },
                        { text: "이미지", value: "imgs", width: 110 },
                        { text: "작성일", value: "createdAt", width: 110, formatter: formatter_dateTime },
                        { text: "", value: "actions", width: 110, align: "right" },
                    ];
                }
            }
        },
        items() {
            return (this.works || []).map((item, index) => ({ ...item, index: +this.summary.totalCount - ((+this.page - 1) * +this.limit + index) }));
        },
        page() {
            return +(this.$route.query.page || "1");
        },
        skip() {
            return (this.page - 1) * this.limit;
        },
        pageCount() {
            return Math.ceil(this.summary.totalCount / this.limit) || 1;
        },
        params() {
            let { ...query } = this.$route.query;

            delete query.page;

            return { ...query };
        },
    },
    methods: {
        init() {
            this.works = [];
            this.summary = { totalCount: 0 };
            this.loading = false;

            this.search();
        },
        manualSearch() {
            this.page = 1;
            this.search();
        },
        async search() {
            if (this.loading) return;
            else this.loading = true;

            try {
                let { skip, limit, params } = this;
                let { summary, works } = await api.console.auction.works.gets({
                    headers: { skip, limit },
                    params,
                });

                this.works = works;
                this.summary = summary;
            } finally {
                this.loading = false;
            }
        },
        async remove(item) {
            if (!confirm(`작가를 삭제하시겠습니까?\n\n제목:    "${item?.subject || ""}"\n작성일: ${item?.createdAt?.toDateTime()}`)) return;

            await api.console.auction.works.delete(item);
            this.works = this.works.filter((content) => content._id !== item._id);
            alert("작가가 삭제되었습니다.");
        },
        async save(item) {
            const { work } = await api.console.auction.works.put(item);
            this.update(work);
        },
        async update(item) {
            const index = this.works.findIndex(({ _id }) => _id == item._id);
            if (index > -1) this.works.splice(index, 1, item);
            else {
                this.works = [item, ...this.works];
                this.totalCount += 1;
            }
        },
        async email(item) {
            const go = confirm(`다음의 내용으로 낙찰 통보서를 발송합니다.\n\n작가/작품: ${item?.author?.name?.ko || "미상"} / ${item?.subject || "무제"}\n수신자: ${item?.price_auction?.bid?.user?.email || "없음"}`);

            if (go) await api.console.auction.works.postWonEmail(item);
        },
    },
    watch: {
        params() {
            this.search();
        },
    },
    mounted() {
        this.init();
    },
};
</script>
